// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"571":"settings","925":"notifi","930":"task"}[chunkId] + "." + {"571":"424448b1","925":"637c6ede","930":"178ce0e5"}[chunkId] + ".css";
};